export default "__VITE_ASSET__Dg1Vgw06__"